export default __webpack_public_path__ + "static/media/umbrellaFilled.c646fa1c.svg";